import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { GET_TENANT, DELETE_TENANT } from "../actions";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

import {
  getTenantSuccess,
  getTenantError,
  trashTenantSuccess,
  trashTenantError,
} from "./actions";

export function* watchGetTenant() {
  yield takeEvery(GET_TENANT, getTenant);
}

export function* watchTrashTenant() {
  yield takeEvery(DELETE_TENANT, trashTenant);
}

const getTenantAsync = async (payload) => {
  try {

    const recordTenantReturned = await centralApiAxios.get(
      "tenants/" + payload.tenantName
      ,getActivityHeadersUpdated(payload)
    );
    let primaryContact = null;
    let primaryOrganizationContact = null;
    if (recordTenantReturned.data) {
      if (recordTenantReturned.data.primary_contact_id > 0) {
        const primaryContactReturned = await centralApiAxios.get(
          `/Contacts/${recordTenantReturned.data.primary_contact_id}`
        );
        if (primaryContactReturned.data) {
          primaryContact = primaryContactReturned.data;
        }
      }
      if (recordTenantReturned.data.primary_organization_contact_id > 0) {
        const primaryOrganizationContactReturned = await centralApiAxios.get(
          `/Contacts/${recordTenantReturned.data.primary_organization_contact_id}`
          ,getActivityHeadersUpdated(payload)
        );
        if (primaryOrganizationContactReturned.data) {
          primaryOrganizationContact = primaryOrganizationContactReturned.data;
        }
      }
      return {
        tenant: recordTenantReturned.data,
        primaryContact: primaryContact,
        primaryOrganizationContact: primaryOrganizationContact,
        message: null,
      };
    }
    return { message: "Get tenant details failed." };
  } catch (error) {
    return {
      message: "Failed to get tenant. ",
    };
  }
};

function* getTenant({ payload }) {
  try {
    const returnedData = yield call(getTenantAsync, payload);
    if (!returnedData.message) {
      yield put(
        getTenantSuccess({
          tenant: returnedData.tenant,
          primaryContact: returnedData.primaryContact,
          primaryOrganizationContact: returnedData.primaryOrganizationContact,
        })
      );
    } else {
      yield put(getTenantError(returnedData.message));
    }
  } catch (error) {
    yield put(getTenantError(error));
  }
}

const trashTenantAsync = async (payload) => {
  try {
    const recordTenantReturned = await centralApiAxios.delete(
      "tenants?tenant_name=" + payload.tenantName
    );
    if (recordTenantReturned.data) {
      return {
        successMessage: "Trash Tenant was successful.",
        message: null,
      };
    }
    return { message: "Trash Tenant failed." };
  } catch (error) {
    return {
      message: "Trash Tenant failed.",
    };
  }
};

function* trashTenant({ payload }) {
  try {
    const returnedData = yield call(trashTenantAsync, payload);
    if (!returnedData.message) {
      yield put(trashTenantSuccess(returnedData.successMessage));
    } else {
      yield put(trashTenantError(returnedData.message));
    }
  } catch (error) {
    yield put(trashTenantError(error));
  }
}

export default function* rootSaga() {
  yield all([fork(watchGetTenant), fork(watchTrashTenant)]);
}
